// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'user',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'date',
    Object: 'value',
    label: '',
    width: '150'
  }, {
    prop: 'result',
    label: '',
    Object: 'value',
    width: '150'
  }]
}
